import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-xueke",
  "use": "icon-xueke-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-xueke\"><path d=\"M555.5 925.3V123.6l68.1-43.9c6.3-4.5 14.1-7.2 22.4-7.2h277c34.5 1.2 62.1 29.5 62.1 64.3v699.5c-1.8 31.8-26.6 57.4-58 60.4H655l-105.6 61c-9.6 4.6-20 6.6-30.4 6.2 20.4-1.1 36.5-17.9 36.5-38.6zM473.4 925.3V123.6l-68.1-43.9c-6.3-4.5-14.1-7.2-22.4-7.2h-277c-34.5 1.2-62.1 29.5-62.1 64.3v699.5c1.8 31.8 26.6 57.4 58 60.4H374l105.6 61c9.6 4.6 20 6.6 30.4 6.2-20.4-1.1-36.6-17.9-36.6-38.6z\" fill=\"#FFFFFF\" /><path d=\"M392.6 309.4c0-22.6-18.3-41-41-41h-88.1c-22.6 0-41 18.3-41 41 0 22.6 18.3 41 41 41h88.1c22.6-0.1 41-18.4 41-41zM392.6 492.4c0-22.6-18.3-41-41-41H243.5c-22.6 0-41 18.3-41 41 0 22.6 18.3 41 41 41h108.1c22.6-0.1 41-18.4 41-41zM392.6 675.4c0-22.6-18.3-41-41-41h-78.1c-22.6 0-41 18.3-41 41 0 22.6 18.3 41 41 41h78.1c22.6 0 41-18.4 41-41z\" fill=\"#FFFFFF\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/xueke.svg
// module id = lsW7
// module chunks = 65